import { render, staticRenderFns } from "./SiteMap.vue?vue&type=template&id=844887c0"
import script from "./SiteMap.vue?vue&type=script&lang=ts"
export * from "./SiteMap.vue?vue&type=script&lang=ts"
import style0 from "./SiteMap.vue?vue&type=style&index=0&id=844887c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports